import React from 'react';
import { useNavigate } from 'react-router-dom';
import { XCircle, ArrowLeft } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

export default function PaymentCancel() {
  const navigate = useNavigate();
  const { userType, landlordType } = useAuth();

  const fallbackPath = userType === 'landlord'
    ? (landlordType === 'agency' ? '/landlord/agency/billing' : '/landlord/billing')
    : '/';

  return (
    <div className="min-h-screen bg-gradient-to-br from-red-50 to-orange-50 flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-xl p-8 text-center">
        <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6">
          <XCircle className="w-12 h-12 text-red-600" />
        </div>
        
        <h1 className="text-3xl font-bold text-gray-900 mb-4">
          Betaling Geannuleerd
        </h1>
        
        <p className="text-gray-600 mb-6">
          Je betaling is geannuleerd. Er is niets afgeschreven. Je kunt op elk moment opnieuw proberen.
        </p>

        <button
          onClick={() => {
            navigate(fallbackPath);
          }}
          className="w-full flex items-center justify-center space-x-2 px-6 py-3 bg-gray-600 text-white rounded-lg hover:bg-gray-700 transition-colors"
        >
          <ArrowLeft className="w-5 h-5" />
          <span>Terug naar Dashboard</span>
        </button>
      </div>
    </div>
  );
}

